import {
    getBikeListRequest,
    getCarListRequest,
    getCommercialListRequest,
} from '../../../../services/network/search/sell';

class CommonSellSearchService {
    async getCarSearchList(data) {
        return await getCarListRequest(data);
    }

    async getBikeSearchList(data) {
        return await getBikeListRequest(data);
    }

    async getCommercialSearchList(data) {
        return await getCommercialListRequest(data);
    }
}

export const SellSearchService = new CommonSellSearchService();
